var map = {
	"./i-arrow.svg": "Zuiq",
	"./i-big-file.svg": "ynjO",
	"./i-cart.svg": "8NbZ",
	"./i-chevron.svg": "ZjsA",
	"./i-clock.svg": "MPF6",
	"./i-close.svg": "KA1/",
	"./i-compare.svg": "Mhfg",
	"./i-facebook.svg": "mkRx",
	"./i-file.svg": "a5zL",
	"./i-filter.svg": "klt8",
	"./i-grid.svg": "Wusy",
	"./i-industry-solutions-01.svg": "hJyC",
	"./i-instagram.svg": "DCf3",
	"./i-list.svg": "EK4P",
	"./i-login.svg": "HM6g",
	"./i-logo.svg": "c3ez",
	"./i-mail.svg": "UpkJ",
	"./i-phone.svg": "VKG1",
	"./i-safety.svg": "y1z2",
	"./i-search.svg": "D2Jq",
	"./i-slider-next.svg": "fmE8",
	"./i-subscribe.svg": "iay+",
	"./i-telegram.svg": "pN/K",
	"./i-transport.svg": "Hy5i",
	"./i-triangle.svg": "lXRY",
	"./i-twitter.svg": "4z60",
	"./i-vk.svg": "VJjS",
	"./i-watsapp.svg": "9q91",
	"./i-youtube.svg": "BOno"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l8Ks";